import { Injectable } from '@angular/core';
import { RequestsServices } from 'src/app/services/requests.service';

@Injectable()
export class TermsService {

  constructor(
    private request: RequestsServices,
  ) {}

  acceptTerm(termId) {
    return this.request.post('acceptance_terms', {termId}, '', '/accept');
  }

  acceptAllTerms(termIds: string[]) {
    const termPromises = termIds.map(termId => this.acceptTerm(termId));
    return Promise.all(termPromises);
  }

  async getTermsToAccept(): Promise<string[]> {
    return Promise.resolve(await this.validateTerms());
  }

  private async validateTerms(): Promise<string[]> {
    const termsToAccept = [];
    try {
      await this.validate();
    } catch (httpErrorResponse) {
      const error = httpErrorResponse.error;
      if (error) {
        if (error.terms) {
          error.terms.forEach(term => termsToAccept.push(term.id));
        } else if (error.currentTerms) {
          error.currentTerms.forEach(termId => termsToAccept.push(termId));
        }
      }
    }

    return termsToAccept;
  }

  private validate() {
    return this.request.get({path: 'acceptance_terms', endPoint: '/validate'});
  }
}

